import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { routes } from 'routes/routes';
import type { OnboardingTourLocationState } from '../page-onboarding-tour';
import { useGetFinalReferer } from './useGetFinalReferer';

type P = {
  referrer?: string;
};

// eslint-disable-next-line @typescript-eslint/naming-convention -- Its a constant
const DEFAULT_PROPS: P = {} as const;

export const useOnSuccessLogin = <T extends { originalState?: unknown; referrer?: string }>({
  referrer,
}: P = DEFAULT_PROPS) => {
  const navigate = useNavigate();
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- useLocation returns state as any
  const state: T | undefined = location.state;
  const getFinalReferer = useGetFinalReferer();

  return useMemo(
    () => ({
      async onSuccessLogin() {
        const finalReferer = getFinalReferer({ referrer, state });

        if (finalReferer.startsWith(window.origin)) {
          window.location.href = finalReferer;
        } else {
          await navigate(finalReferer);
        }
      },
      async onSuccessOnboardingTour() {
        const finalReferer = getFinalReferer({ referrer, state });
        await navigate(finalReferer, { state: state?.originalState });
      },
      async onSuccessSignUp() {
        const finalReferer = getFinalReferer({ referrer, state });
        await navigate(routes.onboardingTour.index, {
          state: { referrer: finalReferer } satisfies OnboardingTourLocationState,
        });
      },
    }),
    [getFinalReferer, navigate, referrer, state],
  );
};
